import { render, staticRenderFns } from "./LoadLocalisation.vue?vue&type=template&id=42f2488e&scoped=true"
import script from "./LoadLocalisation.vue?vue&type=script&lang=js"
export * from "./LoadLocalisation.vue?vue&type=script&lang=js"
import style0 from "./LoadLocalisation.vue?vue&type=style&index=0&id=42f2488e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f2488e",
  null
  
)

export default component.exports